import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IUnitGenericDetailsModel } from '@apps-common/types/portal/unit'

const getUnitInactiveById = async (id: string): Promise<IUnitGenericDetailsModel> =>
  axios.get(`/Unit/GetInactiveUnitById?id=${id}`).then((res) => res.data?.data)

type QueryFnType = typeof getUnitInactiveById

type Props = {
  config?: QueryConfig<QueryFnType>
  id: string
}

export const useGetUnitInactiveById = ({ config, id }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: ['getUnitInactiveById', id],
    queryFn: () => getUnitInactiveById(id)
  })
